import {pluginsGetApi} from "../../../../../../Model/Network/Config/Axios";


class Model {

    init = (cb) => {
        pluginsGetApi(`plugins/mailApproval/approvals`, cb)
    }
}

export default Model;
